<template>
  <header class="header">
    <div class="header_navigation">
      <router-link :to="{ name: 'home' }" class="header_logo">
        <img
          class="header_logo_logo"
          src="../assets/img/logo.svg"
          title="SECOM Sights logo"
          alt=""
        />
      </router-link>
      <template v-if="settings.loggedIn">
        <router-link :to="{ name: 'home' }" class="header_navigation_link">
          ホーム
        </router-link>
        <router-link
          v-if="!noCameraFound"
          :to="{ name: 'multi-camera' }"
          class="header_navigation_link"
        >
          マルチカメラ
        </router-link>
        <router-link
          v-if="!noCameraFound"
          style="display: none"
          :to="{ name: 'events' }"
          class="header_navigation_link header_navigation-disabled"
        >
          イベント一覧
        </router-link>
        <router-link
          v-if="showClipMenu && !noCameraFound"
          id="header-menu-trim-video"
          :to="{ name: 'clip' }"
          class="header_navigation_link"
          :class="{
            'header_navigation_link--pointer': routeName !== 'clip',
          }"
        >
          ビデオクリップ一覧
        </router-link>
        <!-- Map Menu -->
        <Map v-if="!showClipMenu && false" />
        <router-link
          v-if="!noCameraFound"
          style="display: none"
          :to="{ name: 'history' }"
          class="header_navigation_link header_navigation-disabled"
        >
          通信履歴
        </router-link>
        <a
          v-if="!showClipMenu && false"
          class="map_link"
          color="indigo"
          dark
          @click.stop="handleOpenHomeDialog"
        >
          表示カメラ選択
        </a>
      </template>
    </div>
    <div class="header_data">
      <header-menu v-if="!hideHeader" />
      <account-card :is-owner="isOwner">
        <template v-slot:activator="{ on, attrs }">
          <span
            v-bind="attrs"
            class="header_user"
            :class="{
              'header_user--active': $route.name.startsWith('account'),
            }"
            v-on="on"
          >
            <img
              v-if="isOwner"
              src="@/assets/img/ico_account_owner.svg"
              alt=""
            />
            <span v-else class="header_user_icon icon icon-user" />
            <span v-if="false" class="header_user_text">{{ avatarName }}</span>
          </span>
        </template>
      </account-card>
    </div>
    <home-layout-dialog
      :open="homeDialogOpen"
      @onClose="handleCloseHomeDialog"
    />
  </header>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import AuthService from '@/services/auth.service';
import HomeLayoutDialog from '@/components/dialogs/HomeLayoutDialog.vue';
import Map from './Map.vue';
import AccountCard from '@/components/AccountCard.vue';
import HeaderMenu from '@/components/HeaderMenu.vue';

export default {
  name: 'Header',
  components: {
    Map,
    HomeLayoutDialog,
    AccountCard,
    HeaderMenu,
  },
  data: () => ({
    authService: new AuthService(),
    homeDialogOpen: false,
    selectedCamGroup: 1,
  }),
  computed: {
    ...mapGetters('common', {
      updateVersionExists: 'updateVersionExists',
    }),
    ...mapState({
      settings: (state) => state.settings,
      userInfo: (state) => state.common.userInfo,
      noCameraFound: (state) => state.common.noCameraFound,
      currentCameraPolicy: (state) => state.common.currentCameraPolicy,
      avatarName: (state) => state.settings.avatarName,
      currentAvatarId: (state) => state.settings.currentAvatarId,
      isCurrentAvatarOwner: (state) => state.settings.isCurrentAvatarOwner,
      avatarOwnerIds: (state) => state.settings.avatarOwnerIds,
    }),
    showClipMenu() {
      return this.isCurrentAvatarOwner || !this.currentCameraPolicy.liveOnly;
    },
    routeName() {
      return this.$route.name;
    },
    isOwner() {
      return this.avatarOwnerIds.includes(this.currentAvatarId);
    },
    hideHeader() {
      return (
        this.$route.name.startsWith('settings') ||
        this.$route.name.startsWith('account') ||
        this.$route.name.startsWith('help')
      );
    },
  },
  methods: {
    handleOpenHomeDialog() {
      this.homeDialogOpen = true;
    },
    handleCloseHomeDialog() {
      this.homeDialogOpen = false;
    },
    async init() {
      const userInfo = await this.authService.getCurrentUserInfo();
      this.userInfo = userInfo;
    },
    logout() {
      this.authService.logout();
    },
  },
};
</script>

<style lang="scss">
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  height: 24px;
  width: 100%;
  min-width: 1000px;
  box-sizing: border-box;
  &_camgroup {
    width: 120px;
    .v-text-field {
      padding-top: 0;
      margin-top: 0;
      .v-input__append-inner {
        padding-left: 0;
      }
    }
    .v-input__slot {
      margin-bottom: 0;
    }
    .v-text-field__details {
      display: none;
    }
    .v-select__selection {
      flex-grow: 1;
      text-align: right;
      margin-right: 0;
      max-width: 100%;
    }
    .v-text-field input {
      width: 0;
      flex-grow: 0;
    }
    .v-select__selection.v-select__selection--comma {
      font-size: 12px;
      font-weight: 600;
      color: #989898;
    }
    .v-text-field > .v-input__control > .v-input__slot:before {
      content: none;
    }
    .v-text-field > .v-input__control > .v-input__slot:before {
      border-style: none;
    }
    .v-text-field > .v-input__control > .v-input__slot:after {
      border-style: none;
    }
  }
  &_circle-icon {
    width: 9px;
    height: 9px;
    background-color: #fcc800;
    border-radius: 50%;
    position: absolute;
    top: 0;
    right: 2px;
  }
  &_navigation {
    display: flex;
    align-items: center;
    &-disabled {
      opacity: 0.6;
      pointer-events: none;
    }
    &_link {
      margin-left: 20px;
      font-size: 13px;
      font-weight: normal;
      line-height: 18px;
      .header & {
        color: #666;
      }
      &:hover {
        text-decoration: underline;
      }
      &.router-link-active {
        font-weight: 600;
        cursor: text;
        color: var(--primary-color);
        transform: scale(1.15);
        &:hover {
          text-decoration: none;
        }
      }
      &--pointer {
        &.header_navigation_link.router-link-active {
          cursor: pointer;
        }
      }
    }
  }
  &_logo {
    display: flex;
    align-items: center;
    &_logo {
      height: 21.8px;
      width: 150px;
      margin-right: 10px;
    }
  }
  &_data {
    display: flex;
    align-items: center;
  }
  &_user {
    display: flex;
    align-items: center;
    margin: 15px;
    height: 18px;
    img {
      filter: invert(0.5) sepia(0.5) saturate(0.5) hue-rotate(181deg);
    }
    &--active {
      .header_user_icon,
      .header_user_text {
        color: #0075c2;
      }
      img {
        filter: none;
      }
    }

    &_icon {
      font-size: 16px;
      line-height: 17px;
      color: var(--text-color);
    }
    &_text {
      font-size: 12px;
      margin-left: 5px;
      color: var(--text-color);
      padding-bottom: 3px;
    }
  }
  &_settings {
    margin-left: 33px;
    margin-bottom: -4px;
    position: relative;
    width: 20px;

    .icon.icon-cog {
      font-size: 16px;
      color: var(--text-color);
    }
    &.router-link-active {
      .icon.icon-cog {
        color: var(--primary-color);
      }
    }
  }
  &_menu {
    &_list {
      &.v-list {
        padding: 0;
      }
    }
  }
}
</style>
